import type { TranslateFn } from '../types/i18n';

/**
 * De backend blijft Nederlands (zie het migratieplan: e-mails, meldingen en
 * exception-teksten vallen buiten scope). Zijn foutteksten komen wél op het scherm,
 * dus vertalen we hier de handvol berichten die gebruikers daadwerkelijk tegenkomen.
 *
 * De sleutel is de letterlijke Nederlandse tekst uit de backend. Verandert die daar,
 * dan valt hij hier gewoon terug op de onvertaalde tekst - vervelend, maar nooit stuk.
 * De bron staat in `backend/src/auth/auth.service.ts` en `backend/src/teams/`.
 */
const BACKEND_MESSAGE_KEYS: Record<string, string> = {
  'Onjuiste inloggegevens': 'auth:backend.invalidCredentials',
  'Een account met dit email adres bestaat al': 'auth:backend.emailTaken',
  'Gebruiker niet gevonden': 'auth:backend.userNotFound',
  'Huidig wachtwoord is onjuist': 'auth:backend.currentPasswordWrong',
  'Nieuw wachtwoord moet verschillen van het huidige wachtwoord': 'auth:backend.passwordMustDiffer',
  'Ongeldig of verlopen reset token': 'auth:backend.invalidResetToken',
  'Ongeldig of verlopen verificatie token': 'auth:backend.invalidVerificationToken',
  'Email is al geverifieerd': 'auth:backend.alreadyVerified',
  'Deze uitnodiging is niet geldig of verlopen': 'auth:backend.invitationInvalid',
  'Apple-aanmelding kon niet worden voltooid.': 'auth:apple.failed',
  'Dit account gebruikt Inloggen met Apple.': 'auth:apple.required',
  'Inloggen met Apple is op deze omgeving niet ingesteld.': 'auth:backend.appleNotConfigured',
  // Deze twee stuurt de backend in het Engels; ook die horen vertaald te worden.
  'Invalid or expired invitation': 'auth:backend.invitationInvalid',
  'User account not found': 'auth:backend.userNotFound',
};

/**
 * Vertaalt een backend-fouttekst als we hem kennen, en geeft hem anders ongewijzigd terug.
 *
 * Matcht ook wanneer de tekst ergens ín het bericht zit, omdat `ApiError.message` de
 * statusregel ervoor plakt.
 */
export const translateBackendMessage = (t: TranslateFn, message: string | undefined | null): string => {
  if (!message) return '';

  const exact = BACKEND_MESSAGE_KEYS[message.trim()];
  if (exact) return t(exact);

  for (const [dutch, key] of Object.entries(BACKEND_MESSAGE_KEYS)) {
    if (message.includes(dutch)) return t(key);
  }

  return message;
};
